<template>
  <v-card
    v-if="methods && methods.length"
    class="px-3 py-3">
    <v-list>
      <div
        v-for="(method, index) in methods"
        :key="`${index}-method`"
      >
        <v-list-tile
          @click="$emit('selectMethod', method)"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ method.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider
          v-if="index !== methods.length-1"
        />
      </div>
    </v-list>
  </v-card>
</template>

<script>

export default {
  name: 'ShippingList',

  props: {
    methods: {
      type: Array,
      default: () => []
    }
  }
}
</script>
